import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { AdvertListFilterItem } from '@edikk-edikk/country-frontend';
import classNames from 'classnames';
import contentItemCss from '#srcCssModules/advert/list-filter/advert-list-filter-content-item.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

type PropsType = {
  filterItem: AdvertListFilterItem;
};

const FilterItemDetail: FC<PropsType> = ({
  filterItem,
}) => {
  const { onChangeSubject, hideDetail } = useFilterContext();

  return (
    <Button
      variant={ButtonVariant.unstyled}
      navLinkProps={{
        to: filterItem.link.to,
        state: filterItem.link.state,
        end: true,
        onClick: () => {
          onChangeSubject.next(filterItem.link.to);
          hideDetail();
        },
        className: contentItemCss.advertListFilterContentItem,
        activeClassName: classNames(
          contentItemCss.advertListFilterContentItem_active,
          contentItemCss.advertListFilterContentItem_black,
        ),
      }}
    >
      <div className={contentItemCss.advertListFilterContentItem__content}>
        <div>
          {filterItem.getVisibleTitle()}
        </div>
        <div className={contentItemCss.advertListFilterContentItem__counter}>
          (
          {filterItem.numberOfAdverts}
          )
        </div>
      </div>
    </Button>
  );
};

export { FilterItemDetail };
